<template>
  <div class="user-info-container">
    <div class="user-info-container__title">
      Данные профиля доставки
    </div>
    <el-row :gutter="20">
      <template v-for="item in getUserInfoItems">
        <el-col
          :sm="8"
          :xs="24"
          :key="item.id">
          <component
            :is="getComponentName(item.code)"
            :item="item"
            @callback="callback"/>
        </el-col>
      </template>
    </el-row>
    <ErrorMessage
      v-if="isShowErrorMessage"
      :class-list="['user-info-errors']"
      :errors="getErrorsMessage"/>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import UserInfoItem from './UserInfoItem'
  import UserInfoItemPhone from './UserInfoItemPhone'
  import UserInfoBlock from './UserInfoBlock'
  import UserInfoBlockInn from './UserInfoBlockInn'
  import ErrorMessage from '../ErrorMessage'
  import reduce from 'lodash/reduce'
  import validation from '../../../utils/validation'

  export default {
    name: 'UserInfoList',
    components: {
      UserInfoItem,
      UserInfoItemPhone,
      ErrorMessage,
      UserInfoBlock,
      UserInfoBlockInn
    },
    data: function () {
      return {
        isErrorInn: false
      }
    },
    computed: {
      ...mapGetters('order', [
        'getUserInfo',
        'getPersonalTypeSelected'
      ]),
      isShowErrorMessage: function () {
        let isError = reduce(this.getUserInfo, (r, e) => {
          return r || !validation(e.validation.type)(e.value, e.validation.payload)
        }, false)
        isError = isError || this.isErrorInn
        this.setUserInfoValidate(!isError)
        return isError
      },
      getErrorsMessage: function () {
        const errors = reduce(this.getUserInfo, (r, e) => {
          if (!validation(e.validation.type)(e.value, e.validation.payload)) {
            r.push(`<div>Заполните поле: <b>${e.name}</b></div>`)
          }
          return r
        }, [])

        if (this.isErrorInn) {
          errors.push(`<div>Данный <b>ИНН</b> уже существует</div>`)
        }

        return errors
      },
      getUserInfoItems: function () {
        this.isErrorInn = false
        return this.getUserInfo
      }
    },
    methods: {
      ...mapMutations('order', [
        'setUserInfoValidate'
      ]),
      getComponentName: function (code) {
        if (code === 'PHONE') {
          return 'UserInfoItemPhone'
        } else if (code === 'INN') {
          return 'UserInfoBlockInn'
        } else if (code === 'KPP' ||
          code === 'COMPANY_ADR' ||
          code === 'COMPANY_FACT_ADR' ||
          code === 'COMPANY') {
          return 'UserInfoBlock'
        } else {
          return 'UserInfoItem'
        }
      },
      callback: function ({code, data}) {
        if (code === 'isErrorInn') {
          this.isErrorInn = data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/UserInfo/UserInfoList.vue